export const rolesPermissionsData = [
  {
    key: '1',
    roleName: 'Admin',
    createdAt: '25 Sep 2023, 12:12 pm',
  },
  {
    key: '2',
    roleName: 'Company Owner',
    createdAt: '27 Sep 2023, 07:40 am',
  },
  {
    key: '3',
    roleName: 'Deal Owner',
    createdAt: '29 Sep 2023, 08:20 am',
  },
  {
    key: '4',
    roleName: 'Project Manager',
    createdAt: '25 Sep 2023, 12:12 pm',
  },
  {
    key: '5',
    roleName: 'Client',
    createdAt: '15 Oct 2023, 06:18 pm',
  },
  {
    key: '6',
    roleName: 'Lead',
    createdAt: '29 Oct 2023, 03:10 pm',
  },
];
